<div class="mailhub-container">
  <!-- Header -->
  <div class="mailhub-header">
    <div class="header-left">
      <i class="pi pi-envelope header-icon"></i>
      <span class="header-title">Mailhub</span>
      <span class="header-domain">dibisol.com</span>
      <span style="font-size: 10px; opacity: 0.5; margin-left: 1rem;">v2025-07-03a</span>
    </div>
  </div>

  <!-- Toolbar: Empfaenger-Eingabe + Aktionen -->
  <div class="mailhub-toolbar">
    <div class="toolbar-input-group">
      <input
        pInputText
        type="email"
        [(ngModel)]="recipientAddress"
        placeholder="Empfaenger-Adresse eingeben (z.B. name@dibisol.com)"
        class="recipient-input"
        (keydown)="onKeydownRecipient($event)"
      />
      <p-button
        label="Abrufen"
        icon="pi pi-download"
        (onClick)="onFetchMails()"
        [loading]="fetching"
        [disabled]="!recipientAddress"
      />
    </div>
    <div class="toolbar-actions">
      <p-button
        label="Neue Email"
        icon="pi pi-pencil"
        severity="secondary"
        (onClick)="openNewMail()"
        [disabled]="!recipientAddress"
      />
      <p-button
        label="Antworten"
        icon="pi pi-reply"
        severity="secondary"
        (onClick)="openReply()"
        [disabled]="!selectedEmail"
      />
    </div>
  </div>

  <!-- Status/Fehler -->
  @if (statusMessage) {
    <p-message severity="info" [text]="statusMessage" styleClass="status-msg" />
  }
  @if (errorMessage) {
    <p-message severity="error" [text]="errorMessage" styleClass="status-msg" />
  }

  <!-- Hauptbereich: Splitter mit Liste oben, Detail unten -->
  <p-splitter [style]="{ height: 'calc(100vh - 160px)' }" layout="vertical" [panelSizes]="[40, 60]">
    <ng-template #panel>
      <!-- Email-Liste -->
      <div class="mail-list-panel">
        <p-table
          [value]="emails"
          [scrollable]="true"
          scrollHeight="flex"
          selectionMode="single"
          [(selection)]="selectedEmailId"
          dataKey="id"
          [loading]="loading"
          [rowHover]="true"
          [style]="{'width': '100%'}"
          styleClass="p-datatable-sm p-datatable-striped"
        >
          <ng-template #header>
            <tr>
              <th style="width: 3rem"></th>
              <th style="width: 12rem" pSortableColumn="date_received">
                Datum <p-sortIcon field="date_received" />
              </th>
              <th style="width: 22rem">Absender</th>
              <th>Betreff</th>
              <th style="width: 6rem">Groesse</th>
            </tr>
          </ng-template>
          <ng-template #body let-mail>
            <tr
              (click)="onSelectEmail(mail)"
              [class.selected-row]="selectedEmailId === mail.id"
              class="mail-row"
            >
              <td class="attachment-col">
                @if (mail.has_attachments) {
                  <i class="pi pi-paperclip" pTooltip="Hat Anhaenge"></i>
                }
              </td>
              <td>{{ formatDate(mail.date_received) }}</td>
              <td class="sender-col" [pTooltip]="mail.sender">
                {{ mail.sender_name || mail.sender }}
              </td>
              <td class="subject-col">{{ mail.subject || '(Kein Betreff)' }}</td>
              <td>{{ formatSize(mail.size_bytes) }}</td>
            </tr>
          </ng-template>
          <ng-template #emptymessage>
            <tr>
              <td colspan="5" class="empty-msg">
                @if (recipientAddress) {
                  Keine Emails fuer diese Adresse vorhanden
                } @else {
                  Bitte eine Empfaenger-Adresse eingeben und Emails abrufen
                }
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </ng-template>

    <ng-template #panel>
      <!-- Email-Detail -->
      <div class="mail-detail-panel">
        @if (selectedEmail) {
          <div class="detail-header">
            <div class="detail-subject">{{ selectedEmail.subject || '(Kein Betreff)' }}</div>
            <div class="detail-meta">
              <span><strong>Von:</strong> {{ getSenderDisplay(selectedEmail) }}</span>
              <span><strong>An:</strong> {{ selectedEmail.recipient }}</span>
              <span><strong>Datum:</strong> {{ formatDate(selectedEmail.date_received) }}</span>
            </div>

            <!-- Anhaenge -->
            @if (selectedEmail.attachments.length > 0) {
              <div class="detail-attachments">
                <i class="pi pi-paperclip"></i>
                <span class="att-label">Anhaenge:</span>
                @for (att of selectedEmail.attachments; track att.id) {
                  <span
                    class="att-chip"
                    [class.att-pdf]="isPdf(att)"
                    (click)="openAttachment(att)"
                    [pTooltip]="formatSize(att.size_bytes)"
                  >
                    <i [class]="isPdf(att) ? 'pi pi-file-pdf' : 'pi pi-file'"></i>
                    {{ att.filename }}
                  </span>
                }
              </div>
            }
          </div>

          <div class="detail-body" #mailBody [innerHTML]="getMailBody()"></div>
        } @else {
          <div class="no-selection">
            <i class="pi pi-inbox"></i>
            <span>Email auswaehlen um den Inhalt anzuzeigen</span>
          </div>
        }
      </div>
    </ng-template>
  </p-splitter>

  <!-- PDF-Viewer Dialog -->
  <p-dialog
    [(visible)]="showPdfViewer"
    [header]="pdfFilename"
    [modal]="true"
    [style]="{ width: '80vw', height: '85vh' }"
    [maximizable]="true"
    (onHide)="closePdfViewer()"
  >
    @if (pdfUrl) {
      <iframe [src]="pdfUrl" class="pdf-iframe"></iframe>
    }
  </p-dialog>

  <!-- Compose Dialog -->
  @if (showCompose) {
    <app-mail-compose
      [visible]="showCompose"
      [mode]="composeMode"
      [senderAddress]="recipientAddress"
      [replyToEmail]="replyToEmail"
      [domainConfig]="domainConfig"
      (closed)="onComposeClosed()"
      (sent)="onMailSent()"
    />
  }
</div>
